<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditLandlord
            ? $t("landlord.updateLandlord")
            : $t("landlord.newlandlord")
        }}
      </h1>
      <v-dialog
        height="130px"
        width="500px"
        rounded="lg"
        v-model="errorDialogue"
      >
        <v-card height="130px" width="500px">
          <v-card-title>
            <h4 class="mx-auto">
              {{ $t("landlord.errorOccured") }}
            </h4>
            <v-btn @click="closeDialog" icon rounded color="success">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="red--text text-center">
            <span class="text-h5"> Error Info: {{ this.isError }} </span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ValidationObserver ref="observer" v-slot="{ valid, handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="rerender">
          <div class=" tw-flex tw-justify-start tw-mb-4">
            <!-- <p class="gray1--text mb-1 text-center">
                {{ $t("landlord.lanlordImage") }}
              </p> -->
            <image-uploader
              :maxWidth="200"
              :max-height="200"
              :quality="0.9"
              :preview="true"
              :className="['fileinput', { 'fileinput--loaded': hasLogo }]"
              capture="environment"
              :debug="1"
              doNotResize="gif"
              :autoRotate="true"
              outputFormat="blob"
              @input="setLogo"
              class="ms-5"
              id="logo"
            >
              <label for="logo" slot="upload-label">
                <div class="tw-flex tw-flex-col tw-gap-2">
                  <a>
                    <div v-if="!hasLogo" class="upload-caption gray1--text">
                      <avatar
                        v-if="landlordModel.avatar"
                        class="mx-4"
                        :size="100"
                        :src="
                          `${$store.getters.imageBaseUrl}/${landlordModel.avatar}`
                        "
                      />
                      <avatar
                        v-else
                        :size="100"
                        :username="landlordModel.user.nameEn"
                      />
                    </div>
                  </a>
                  <p class="upload-caption tw-text-sm grey--text my-0">
                    {{
                      hasLogo
                        ? $t("landlord.clicktochange")
                        : $t("landlord.clicktoupload")
                    }}
                  </p>
                </div>
              </label>
            </image-uploader>
          </div>
          <div class=" tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-x-4">
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true, name: /^[A-Za-z\s]+$/ }"
                :name="$t('landlord.nameEn')"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.nameEn')"
                  type="text"
                  v-model="landlordModel.user.nameEn"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.nameEn") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true, arabicText: true }"
                :name="$t('landlord.nameAr')"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.nameAr')"
                  type="text"
                  v-model="landlordModel.user.nameAr"
                  ><template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.nameAr") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                :name="$t('landlord.email')"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.email')"
                  type="text"
                  v-model="landlordModel.user.email"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.email") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
                :name="$t('landlord.companyName')"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.companyName')"
                  type="text"
                  v-model="landlordModel.companyName"
                  ><template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.companyName") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ minPhone: 8, maxPhone: 12, required: true }"
                :name="$t('landlord.phoneNumber')"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  class="numberClass"
                  dense
                  :label="$t('landlord.phoneNumber')"
                  type="number"
                  v-model="landlordModel.user.phone"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.phoneNumber") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.currency.title')"
                  color="secondary"
                  item-text="currency"
                  item-value="_id"
                  :items="currencyList"
                  v-model="landlordModel.currency"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.currency.title") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </div>
            <div v-if="!isEditLandlord">
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('landlord.password')"
                vid="confirm"
                :rules="
                  isEditLandlord
                    ? { minPass: 6, maxPass: 20 }
                    : { minPass: 6, maxPass: 20, required: true }
                "
              >
                <v-text-field
                  :error-messages="errors"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  outlined
                  dense
                  :label="$t('landlord.password')"
                  color="secondary"
                  v-model="landlordModel.user.password"
                  @click:append="show = !show"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.password") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div v-if="!isEditLandlord">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="
                  isEditLandlord
                    ? { minPass: 6, maxPass: 20, confirmed: 'confirm' }
                    : {
                        minPass: 6,
                        maxPass: 20,
                        confirmed: 'confirm',
                        required: true
                      }
                "
                :name="$t('landlord.confirmPassword')"
              >
                <v-text-field
                  :error-messages="errors"
                  :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  outlined
                  data-vv-as="password"
                  dense
                  :label="$t('landlord.confirmPassword')"
                  color="secondary"
                  v-model="confirmPassword"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.confirmPassword") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <!-- <v-col
              cols="12"
              sm="6"
              md="4"
              :lg="isEditLandlord ? 4 : 4"
              class="py-0"
            >
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  v-model="landlordModel.validityPlan"
                  :error-messages="errors"
                  outlined
                  dense
                  :items="landlordValidityPlanLists"
                  item-text="planName"
                  item-value="_id"
                  :label="$t('settings.landlordValidityPlan.title')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.title") }}
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col
              cols="12"
              sm="6"
              md="4"
              :lg="isEditLandlord ? 4 : 4"
              class="py-0"
            >
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-text-field
                      append-icon="mdi-calendar"
                      outlined
                      :error-messages="errors"
                      dense
                      readonly
                      disabled
                      v-bind="attrs"
                      v-on="on"
                      :label="$t('landlord.endDate')"
                      color="secondary"
                      v-model="landlordModel.endDate"
                    >
                      <template #label>
                        <span class="red--text"><strong>* </strong></span
                        >{{ $t("landlord.endDate") }}
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="landlordModel.endDate"
                  @input="dateMenu = false"
                  :min="new Date().toISOString()"
                ></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ phone: 8, required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.contactNumber')"
                  color="secondary"
                  type="number"
                  class="numberClass"
                  v-model="landlordModel.contactNumber"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.contactNumber") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.addressLine1')"
                  color="secondary"
                  type="text"
                  v-model="landlordModel.addressLine1"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.addressLine1") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.area')"
                  color="secondary"
                  v-model="landlordModel.area"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.area") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.block')"
                  color="secondary"
                  v-model="landlordModel.block"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.block") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.streat')"
                  color="secondary"
                  v-model="landlordModel.streat"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.streat") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.country')"
                  color="secondary"
                  v-model="landlordModel.country"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.country") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->

            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <v-text-field
                :error-messages="errors"
                outlined
                dense
                :label="$t('landlord.bio')"
                color="secondary"
                type="text"
                v-model="landlordModel.bio"
              >
                <template #label>
                  {{ $t("landlord.bio") }}
                </template>
              </v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  v-model="landlordModel.paymentTypes"
                  :error-messages="errors"
                  outlined
                  dense
                  multiple
                  color="white--text"
                  :items="paymentTypeOptions"
                  item-text="text"
                  item-value="value"
                  :label="$t('landlord.paymentType')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.paymentType") }}
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  v-model="landlordModel.commissionType"
                  :error-messages="errors"
                  outlined
                  dense
                  :items="commissionOptions"
                  item-text="text"
                  item-value="value"
                  :label="$t('landlord.commissionType')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.commissionType") }}
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                name="Commission"
                :rules="{ required: true, isNumber: landlordModel.commission }"
              >
                <v-text-field
                  :error-messages="errors"
                  :rules="[validateCommission]"
                  outlined
                  dense
                  :label="$t('landlord.commission')"
                  color="secondary"
                  v-model="landlordModel.commission"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.commission") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <div v-if="isEditLandlord">
              <ValidationProvider name="civilId" :rules="{ required: true, civilId: 12 , field :/^[A-Za-z0-9 ]+$/}"
                v-slot="{ errors }">
              :error-messages="errors"
              <v-text-field
                outlined
                maxlength="12"
                dense
                prepend-inner-icon="mdi-clipboard-account"
                :label="$t('customer.civilIdNumber')"
                v-model="landlordModel.civilIdNumber"
              >
                <template #label>
                  <span class="red--text"><strong>* </strong></span
                  >{{ $t("customer.civilIdNumber") }}
                </template>
              </v-text-field>

              </ValidationProvider>
            </div> -->

            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider v-slot="{ errors }" name="35" :rules="{ max: 35, required: true }">
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="`commercialLicenceNo`"
                  v-model="landlordModel.commercialLicenceNo"
                  color="secondary"
                  type="text"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <v-file-input
                label="license copy"
                prepend-icon=""
                append-icon="mdi-folder-open"
                accept=".xlsx, .xls, .pdf, image/*"
                v-model="file1"
                outlined
                dense
              >
              </v-file-input>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <v-file-input
                label="signatory copy"
                outlined
                accept=".xlsx, .xls, .pdf, image/*"
                prepend-icon=""
                append-icon="mdi-folder-open"
                v-model="file2"
                dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <v-file-input
                label="authorized signatory"
                prepend-icon=""
                accept=".xlsx, .xls, .pdf, image/*"
                append-icon="mdi-folder-open"
                v-model="file3"
                outlined
                dense
              ></v-file-input> -->
            <!-- @change="file3 ? getImageUrl(file3, 'file3') : false" -->
            <!-- </v-col> -->

            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0" v-if="isEditLandlord">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="isEditLandlord ? { minPass: 6, maxPass: 20 } : { minPass: 6, maxPass: 20, required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  outlined
                  dense
                  :label="'Old ' + $t('landlord.password')"
                  color="secondary"
                  v-model="landlordModel.user.password"
                  @click:append="show = !show"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <ValidationProvider name="civilId" :rules="{ required: true, civilId: 12 , field :/^[A-Za-z0-9 ]+$/}"
                v-slot="{ errors }">
                <v-text-field outlined maxlength="12" dense prepend-inner-icon="mdi-clipboard-account"
                  :error-messages="errors" :disabled="isEditLandlord ? true : false"
                  :label="$t('customer.civilIdNumber')" v-model="landlordModel.civilIdNumber">
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>{{$t('customer.civilIdNumber')}}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <div v-show="false">
              <ValidationProvider>
                <v-file-input
                  :error-messages="errors"
                  :label="$t('common.fileInput')"
                  prepend-icon=""
                  append-icon="mdi-folder-open"
                  accept=".xlsx, .xls, .pdf, image/*"
                  v-model="landlordModel.civilIdImageFront"
                  ref="civilFront"
                  outlined
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.civilIdImageFront") }}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </div>
            <div v-show="false">
              <ValidationProvider>
                <v-file-input
                  :error-messages="errors"
                  label="Civil ID back side"
                  prepend-icon=""
                  append-icon="mdi-folder-open"
                  accept=".xlsx, .xls, .pdf, image/*"
                  v-model="landlordModel.civilIdImageBack"
                  ref="civilBack"
                  outlined
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("customer.civilIdImageBack") }}
                  </template>
                </v-file-input>
              </ValidationProvider>
            </div> -->
            <!-- <v-col
              cols="12"
              sm="6"
              md="4"
              :lg="isEditLandlord ? 4 : 4"
              class="py-0"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: false, field: /^[A-Za-z0-9 ]+$/ }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.bankName')"
                  v-model="landlordModel.bankName"
                  color="secondary"
                  type="text"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.bankName") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col
              cols="12"
              sm="6"
              md="4"
              :lg="isEditLandlord ? 4 : 4"
              class="py-0"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{
                  required: false,
                  minIban: 10,
                  field: /^[A-Za-z0-9 ]+$/
                }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  :disabled="isEditLandlord ? true : false"
                  dense
                  :label="$t('landlord.iban')"
                  v-model="landlordModel.IBAN"
                  color="secondary"
                  type="text"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.iban") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col> -->

            <div v-if="isEditLandlord">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="
                  isEditLandlord
                    ? { minPass: 6, maxPass: 20 }
                    : { minPass: 6, maxPass: 20, required: true }
                "
              >
                <v-text-field
                  :error-messages="errors"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  outlined
                  dense
                  :label="$t('user.newPassword')"
                  color="secondary"
                  v-model="landlordModel.user.newPassword"
                  @click:append="show1 = !show1"
                >
                </v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div
            class=" tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-y-4 lg:tw-gap-y-0  tw-gap-x-4 tw-items-start"
          >
            <!-- <div class=" tw-flex tw-flex-col tw-gap-1" v-if="isEditLandlord">
              <div class=" tw-text-sm">
                Civil Id Front Image
              </div>
              <div
                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-border-2 tw-border-dashed tw-rounded-lg tw-cursor-pointer tw-h-36 tw-min-h-36 tw-border-border tw-bg-light"
                @click="() => $refs['civilFront'].$refs.input.click()"
                flat
              >
                <v-img
                  class=""
                  max-height="150"
                  max-width="250"
                  v-if="getImageUrl(landlordModel.civilIdImageFront)"
                  :src="getImageUrl(landlordModel.civilIdImageFront)"
                ></v-img>
                <img
                  v-else
                  class=" tw-w-12 tw-opacity-40"
                  src="@/assets/images/cameraUpload.png"
                  alt=""
                />
              </div>
              <div class="text-center">
                <v-btn
                  icon
                  color="info"
                  @click="downloadFiles(landlordModel.civilIdImageFront)"
                >
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </div> -->
            <!-- <div class=" tw-flex tw-flex-col tw-gap-1" v-if="isEditLandlord">
              <div class=" tw-text-sm">
                Civil Id Back Image
              </div>
              <div
                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-border-2 tw-border-dashed tw-rounded-lg tw-cursor-pointer tw-h-36 tw-min-h-36 tw-border-border tw-bg-light"
                @click="() => $refs['civilBack'].$refs.input.click()"
                flat
              >
                <v-img
                  class=""
                  max-height="150"
                  max-width="250"
                  v-if="getImageUrl(landlordModel.civilIdImageBack)"
                  :src="getImageUrl(landlordModel.civilIdImageBack)"
                ></v-img>
                <img
                  v-else
                  class=" tw-w-12 tw-opacity-40"
                  src="@/assets/images/cameraUpload.png"
                  alt=""
                />
              </div>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(landlordModel.civilIdImageBack)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </div> -->
            <!-- <v-col cols="12" sm="6" md="4" lg="4" class="py-3" v-if="isEditLandlord">
              <div>{{ $t('customer.civilIdImageFront') }}</div>
              <v-card outlined class="justify-center">
                <v-img class="" :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${landlordModel.civilIdImageFront}
                `" max-height="150" :src="`
                ${$store.getters.imageBaseUrl}/${landlordModel.civilIdImageFront}
                `"></v-img>
                <div class="text-center">
                  <v-btn icon color="info" @click="downloadFiles(landlordModel.civilIdImageFront)">
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" class="py-3" outlined v-if="isEditLandlord">
              <div>{{ $t("customer.civilIdImageBack") }}</div>
              <v-card outlined class="justify-center">
                <v-img class="" :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${landlordModel.civilIdImageBack}
                `" max-height="150" :src="`
                ${$store.getters.imageBaseUrl}/${landlordModel.civilIdImageBack}
                `"></v-img>
                <div class="text-center">
                  <v-btn icon color="info" @click="downloadFiles(landlordModel.civilIdImageBack)">
                    <v-icon>mdi-cloud-download</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col> -->

            <div v-if="isEditLandlord">
              <v-switch
                class="mt-0"
                v-model="landlordModel.user.active"
                :label="$t('landlord.isActive')"
                color="primary"
              >
                <!-- <template #prepend>
                  <v-label>{{ $t("landlord.isActive") }}</v-label>
                </template> -->
              </v-switch>
            </div>
          </div>

          <div class=" tw-flex tw-justify-end tw-w-full tw-mt-4">
            <!-- <div class="d-flex justify-center"> -->
            <!-- <v-btn class="custom-button text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn> -->
            <v-btn
              class="white--text  px-8"
              color="primary"
              :disabled="!valid"
              type="submit"
              :loading="btnLoading"
              >{{ isEditLandlord ? $t("common.update") : $t("common.save") }}
            </v-btn>
            <!-- </div> -->
          </div>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import { formatDate } from "@/core/methods/formatDate";
import "@/core/methods/validation_rules";
import { createLandlord } from "../../methods/create_landlord";
import { updateLandlord } from "../../methods/update_landlord";
import imageUploader from "vue-image-upload-resize";
import Avatar from "vue-avatar";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      errors: "",
      errorDialogue: false,
      showConfirmPassword: false,
      file1: null,
      file2: null,
      file3: null,
      show: false,
      show1: false,
      btnLoading: false,
      dateMenu: false,
      landlord: {},
      imageFront: null,
      imageBack: null,
      isError: null,
      hasLogo: false,
      landlordValidityPlanLists: [],
      totalLandlordValidityPlan: 0,
      baseUrl: process.env.VUE_APP_BASE_URL,
      landlordModel: {
        user: {
          nameEn: "",
          nameAr: "",
          phone: "",
          password: "",
          active: true,
          email: "",
          newPassword: "",
          customerType: "COMPANY"
        },
        currency: "",
        contactNumber: "",
        commissionType: "",
        commission: "",
        bio: "",
        endDate: "",
        avatar: null,
        paymentTypes: [],
        validityPlan: "",
        civilIdNumber: "",
        // area: "",
        // block: "",
        addressLine1: "",
        // streat: "",
        // country: "",
        companyName: ""
      },
      rerender: 0,
      confirmPassword: "",
      currencyList: []
    };
  },
  components: {
    imageUploader,
    Avatar
  },
  watch: {
    isError(val) {
      if (val) {
        this.errorDialogue = true;
      } else {
        this.errorDialogue = false;
      }
    },
    isEditLandlord: {
      handler() {
        debugger;
        if (this.isEditLandlord) {
          this.landlordModel = this.$format.cloneVariable(this.editLandloard);

          if (this.landlordModel.user !== null)
            this.landlordModel.user.active = this.editLandloard.user.isActive;

          this.landlordModel.endDate = formatDate(this.landlordModel.endDate);
          this.landlordModel.validityPlan = this.landlordModel?.validityPlan?._id;
          if (this.landlordModel.currency && typeof this.landlordModel.currency === 'object') {
            this.landlordModel.currency = this.landlordModel.currency._id;
          }
        } else {
          this.hasLogo = false;
          this.landlordModel = {
            user: {
              nameEn: "",
              nameAr: "",
              phone: "",
              password: "",
              newPassword: "",
              active: true,
              email: "",
              customerType: "COMPANY"
            },
            contactNumber: "",
            commissionType: "",
            commission: null,
            bio: "",
            avatar: null,
            endDate: "",
            paymentTypes: [],
            validityPlan: "",
            civilIdNumber: "",
            area: "",
            block: "",
            addressLine1: "",
            streat: "",
            country: "",
            confirmPassword: "",
            companyName: ""
          };
          this.rerender++;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["editLandloard", "isEditLandlord"]),
    commissionOptions() {
      return [
        { value: "FIXED", text: this.$t("landlord.fixed") },
        { value: "PERCENTAGE", text: this.$t("landlord.percentage") }
      ];
    },
    paymentTypeOptions() {
      return [
        { value: "PAY_ONLINE", text: this.$t("landlord.payOnline") },
        { value: "PAY_AT_PROPERTY", text: this.$t("landlord.payAtProperty") }
      ];
    }
  },
  apollo: {
    getAllCurrencyForAdmin() {
      return {
        query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: ""
          }
        },
        result({ data }) {
          this.currencyList = data.getAllCurrencyForAdmin.currencies;
        }
      };
    },
    getAllLandlordValidityPlan() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.landlordValidityPlanLists =
            data.getAllLandlordValidityPlan.landlordValidityPlans;
          this.loading = loading;
          this.totalLandlordValidityPlan =
            data.getAllLandlordValidityPlan.totalCount;
        }
      };
    },
    getLandlordValidityPlanById() {
      return {
        query: require("@/settings/api/queries/landlord_validity_plan/get_landlord_validity_plan_by_id.graphql"),
        variables() {
          return {
            id: this.landlordModel.validityPlan
          };
        },
        result({ data }) {
          this.validityDatails = data.getLandlordValidityPlanById;
          this.validity = data.getLandlordValidityPlanById.validity;
          this.changeValidity();
        },
        skip() {
          return !this.landlordModel.validityPlan;
        }
      };
    }
  },

  methods: {
    downloadFiles(link) {
      const fileUrl = this.imageBaseUrl + "/" + link;
      var a = document.createElement("a");
      a.href = fileUrl;
      a.setAttribute("download", null);
      a.click();
    },
    closeDialog() {
      this.errorDialogue = false;
      this.isError = null;
      this.rerender += 1;
    },
    changeValidity() {
      console.log(this.validity);
      // debugger
      if (!this.isEditLandlord) {
        this.landlordModel.endDate = formatDate(
          new Date().setDate(new Date().getDate() + this.validity)
        );
      } else {
        // this.landlordModel.endDate=this.editLandloard.endDate
        if (this.validityDatails._id === this.editLandloard.validityPlan._id) {
          this.landlordModel.endDate = formatDate(this.editLandloard.endDate);
        } else
          this.landlordModel.endDate = formatDate(
            new Date(parseInt(this.editLandloard.endDate)).setDate(
              new Date(parseInt(this.editLandloard.endDate)).getDate() +
                this.validity
            )
          );
      }
    },
    async onSave() {
      this.btnLoading = true;
      const input = this.$format.cloneVariable(this.landlordModel);
      input.commission = Number(input.commission);
      // input.commercialLicenceImage = ""
      // input.authorizedSignatoryImage = ""
      // input.civilIdImageOfAuthorizedSignatory =""
      input.civilIdImageBack = this.imageBack;
      input.civilIdImageFront = this.imageFront;
      input.avatar = this.landlordModel.avatar;
      input.paymentTypes=["ONLINE","OFFLINE"];
      if (!this.isEditLandlord) {
        createLandlord(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchLandlord");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.landlordModel = {
              user: {
                nameEn: "",
                nameAr: "",
                phone: "",
                password: "",
                newPassword: "",
                active: true,
                email: "",
                customerType: "COMPANY"
              },
              currency: "",
              contactNumber: "",
              commissionType: "",
              commission: "",
              bio: "",
              endDate: "",
              avatar: null,
              paymentTypes: [],
              validityPlan: "",
              civilIdNumber: "",
              area: "",
              block: "",
              addressLine1: "",
              streat: "",
              country: "",
              companyName: ""
            };
            this.rerender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        const updateData = {
          id: input._id,
          input: {
            user: {
              nameEn: input.user.nameEn,
              nameAr: input.user.nameAr,
              email: input.user.email,
              phone: input.user.phone,
              isActive: input.user.active,
              password: input.user.password,
              newPassword: input.user.newPassword
            },
            contactNumber: input.contactNumber,
            bio: input.bio,
            currency: input.currency,
            // avatar: input.avatar,
            paymentTypes: input.paymentTypes,
            validityPlan: input.validityPlan,
            commissionType: input.commissionType,
            commission: Number(input.commission),
            IBAN: input.IBAN,
            bankName: input.bankName,
            // commercialLicenceNo: input.commercialLicenceNo,
            // authorizedSignatoryImage: "",
            // civilIdImageOfAuthorizedSignatory: "",
            // commercialLicenceImage: "",
            endDate: input.endDate,
            civilIdNumber: input.civilIdNumber,
            civilIdImageFront:
              typeof this.landlordModel.civilIdImageFront === "string"
                ? null
                : this.landlordModel.civilIdImageFront,
            civilIdImageBack:
              typeof this.landlordModel.civilIdImageBack === "string"
                ? null
                : this.landlordModel.civilIdImageBack,
            area: input.area,
            block: input.block,
            addressLine1: input.addressLine1,
            streat: input.streat,
            country: input.country,
            companyName: input.companyName
          }
        };
        if (this.hasLogo) updateData.input.avatar = this.landlordModel.avatar;
        updateLandlord(updateData).then(data => {
          if (data.data) {
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("refetchLandlord");
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
            this.btnLoading = false;
            this.$store.commit("IS_EDIT_LANDLORD", false);
          } else {
            if (data.graphQLErrors.length) {
              this.btnLoading = false;
              this.isError = data.graphQLErrors[0].message;
            }
          }
        });
      }
    },
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_LANDLORD", false);
    // },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    getImageUrl(image) {
      if (image) {
        if (typeof image === "string") {
          return this.$store.getters.imageBaseUrl + "/" + image;
        }
        return URL.createObjectURL(image);
      }
      return null;
    },
    setLogo(output) {
      this.hasLogo = true;
      this.landlordModel.avatar = output;
    },
    formatDate: formatDate,
    validateCommission(value) {
      if (value < 0) {
        this.landlordModel.commission = null;
        return false;
      } else if (this.landlordModel.commissionType === "PERCENTAGE") {
        if (value > 100) {
          this.landlordModel.commission = null;
          return false;
        }
      }
      return true;
    }
  }
};
</script>
<style scoped>
.numberClass >>> input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.numberClass >>> input::-webkit-outer-spin-button,
.numberClass >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
